/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SetExecutionToFailed$Params {
  jobExecutionId: number;
  stepExecutionId: number;
}

export function setExecutionToFailed(
  http: HttpClient,
  rootUrl: string,
  params: SetExecutionToFailed$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setExecutionToFailed.PATH, 'patch');
  if (params) {
    rb.path('jobExecutionId', params.jobExecutionId, {});
    rb.path('stepExecutionId', params.stepExecutionId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

setExecutionToFailed.PATH = '/manage/job/execution/{jobExecutionId}/{stepExecutionId}/setFailed';
